import { useEffect, useMemo, useRef, useState } from "react";

import { useSearchParams } from "react-router-dom";

import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";


import LoadingWheel from "../../components/shared/LoadingWheel";
import { usePageNameContext } from "../../contexts/PageTitleContext";
import useQuotes from "../../data/useQuotes";
import Modal from "../../layouts/Modal";
import { IQuote } from "../../models/Quote";
import QuotesTable from "../../components/quotes/quotesTable";
import SwitchInput from "../../components/shared/Inputs/SwitchInput";
import CustomerSellAVehicleToggle from "../../components/customer/customerSellAVehicleToggle";
import CustomerMarketplaceWebsiteSelect from "../../components/customer/customerMarketplaceWebsiteSelect";

import { useAuth } from "../../contexts/AuthContext";
import { wilmaSAVCustomerId } from "../../config";
import SelectInput from "../../components/shared/Inputs/SelectInput";
import CustomerSelect from "../../components/leads/LeadTable/CustomerSelect";
import { useDebounce } from "@uidotdev/usehooks";

export default function Quotes({ sellavehicle }: { sellavehicle?: boolean }) {
    const { setInfo } = usePageNameContext();
    const { loading, customerId } = useAuth();
  
    const [selectedStep, setSelectedStep] = useState<number>(0);
    const [filterCustomerId, setFilterCustomerId] = useState<string | null>(null);
    const [searchTerm, setSearchTerm] = useState<string>("");

    const customUrlQuery = useMemo(() => {
        var base = "step=" + selectedStep + (filterCustomerId ? "&filterCustomerId=" + filterCustomerId : "");
        if (sellavehicle) {
            base += "&sellavehicle=true";
        }
        return base;
    }, [sellavehicle, selectedStep, filterCustomerId]);

    const Step = ({step, name, colour} : {step: number, name: string, colour: string}) => {
        const colourClass = "bg-" + colour + "-200";
        return (
            <div className={`bg-white px-4 py-2 rounded-lg shadow flex items-center group ${selectedStep == step ? "scale-110" : ""}
                transion-transform hover:scale-110 cursor-pointer duration-100 hover:duration-200`}
                onClick={() => {
                    setSelectedStep(selectedStep == step ? 0 : step);
                }}
            >
                {step}: {name} <div className={`rounded-full ${colourClass} h-4 w-4 ml-4`}></div>
            </div>
        )
    }

    useEffect(() => {
        setInfo({
            name: sellavehicle ? "SellAVehicle Quotes" : "Quote History",
            desc: sellavehicle ? "View and manage your SellAVehicle quotes here" : "View and manage your quotes here",
        });
    }, [sellavehicle]);


    return (
        <>
            <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:justify-between sm:items-start">
                <div className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-5"> 
                    <div className="relative flex items-stretch w-full sm:w-auto sm:flex-grow focus-within:z-10">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <MagnifyingGlassIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </div>
                        <input
                        type="text"
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="pl-10 sm:text-sm w-full sm:w-auto"
                        placeholder="Name, VRM or Postcode"
                        />
                    </div>
                    {customerId === wilmaSAVCustomerId && (
                        <CustomerSelect onChange={(custId) => {
                            setFilterCustomerId(custId);
                        }} />
                    )}
                </div>

                {sellavehicle && (
                    <div className="flex flex-col items-stretch sm:items-end gap-2">
                        <CustomerSellAVehicleToggle />
                        <div className="w-full sm:w-72">
                            <CustomerMarketplaceWebsiteSelect />
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-wrap gap-2 sm:gap-4 mt-4">
                <Step step={1} name="Confirm"  colour="gray"   />
                <Step step={2} name="Engine"   colour="gray"   />
                <Step step={3} name="Body"     colour="gray"   />
                <Step step={4} name="Contact"  colour="gray"   />
                <Step step={5} name="Prices"   colour="orange" />
                <Step step={6} name="Personal" colour="yellow" />
                <Step step={7} name="Payment"  colour="green"  />
                <Step step={8} name="Complete" colour="purple"  />
            </div>

            <QuotesTable 
                url={"/quote/abandoned/paginated"} 
                queryKey={"abandonedQuotes" + (sellavehicle ? "SellAVehicle" : "")}
                isSav={customerId === wilmaSAVCustomerId} 
                customUrlQuery={customUrlQuery}
                externalQuery={searchTerm}
            />
                
        </>
    );
    
          
}